import { QueryFunction } from '@tanstack/react-query';

import { handleErrors } from '@/shared/lib/errors';

import { apiWrapper } from '@/shared/api/main';

import { TClassifiers } from '@/shared/types/classifiers';
import { IErrorResponseData } from '@/shared/types/error';

/**
 * Получение общих классификаторов
 * @param params - Объект ключа запроса.
 * @param params.queryKey - массив содержащий базовый url
 */
export const getClassifiers: QueryFunction<TClassifiers> = async ({
  queryKey
}) => {
  const queryUrl = queryKey[0] as string;

  const response = await apiWrapper.get<TClassifiers, IErrorResponseData>(
    queryUrl
  );

  if (!response.ok) {
    const { mainError } = handleErrors(response);

    throw new Error(mainError);
  }

  return response.data || ({} as TClassifiers);
};
